import type { FormatNumberProps, TextProps } from '@chakra-ui/react';
import { FormatNumber, Text } from '@chakra-ui/react';
import React from 'react';

interface CurrencyTextProps extends FormatNumberProps {
  value: number;
  currency: string; // e.g., 'EUR', 'USD'
  fontWeight?: TextProps['fontWeight'];
  color?: TextProps['color'];
  prefix?: string;
  fontSize?: TextProps['fontSize'];
  textProps?: TextProps;
}

const Money: React.FC<CurrencyTextProps> = ({
  value,
  currency,
  fontWeight = 'normal',
  color,
  prefix,
  fontSize = 'md',
  textProps,
  ...props
}) => {
  return (
    <Text fontWeight={fontWeight} color={color} fontSize={fontSize} {...textProps}>
      {prefix}
      <FormatNumber value={value} style="currency" currency={currency} {...props} />
    </Text>
  );
};

export default Money;
